if (!customElements.get('announcement-bar-countdown')) {
  customElements.define(
    'announcement-bar-countdown',
    class AnnouncementBarCountdown extends HTMLElement {
      constructor() {
        super();
        this.date = this.dataset.date;
        this.time = this.dataset.time;
        this.content = this.dataset.content;
        this.contentComplete = this.dataset.contentcomplete;
        this.countdownDate = new Date(this.date + 'T' + this.time + 'Z');
        this.hideOnComplete = this.dataset.hide;
        this.linkBeforeComplete = this.dataset.link;
        this.linkComplete = this.dataset.linkcomplete;
        this.ticker = null;
      }

      connectedCallback() {
        if (this.isComplete()) {
          if (this.hideOnComplete == 'true') {
            this.style.display = 'none';
            document.getElementById('content').innerHTML = '';
          } else {
            if (this.linkComplete != '') {
              document.getElementById('linkAnnouncement').setAttribute('href', this.linkComplete);
            }
            if (this.contentComplete != '') {
              document.getElementById('content').innerHTML = this.contentComplete;
            }
          }
          this.erase();
        } else if (this.countdownDate instanceof Date && isNaN(this.countdownDate)) {
          document.getElementById('content').innerHTML = this.content;
          this.erase();
        } else {
          if (this.linkBeforeComplete != '') {
            document.getElementById('linkAnnouncement').setAttribute('href', this.linkBeforeComplete);
          }
          document.getElementById('content').innerHTML = this.content;
          this.tick();
          this.ticker = this.timer();
        }
      }

      disconnectedCallback() {
        clearTimeout(this.ticker);
      }

      countdown() {
        const rawDiff = this.countdownDate.getTime() - new Date().getTime();

        const diff = Math.floor(rawDiff / 1000);
        const days = Math.floor(diff / (24 * 60 * 60));
        const hours = Math.floor((diff % (24 * 60 * 60)) / (60 * 60));
        const minutes = Math.floor((diff % (60 * 60)) / 60);
        const seconds = Math.floor(diff % 60);

        return {
          rawDiff,
          days,
          hours,
          minutes,
          seconds,
        };
      }

      isComplete() {
        return this.countdownDate < new Date();
      }

      tick() {
        var cd = this.countdown();
        document.getElementById('days').innerHTML = cd.days + ':';
        document.getElementById('hours').innerHTML = cd.hours > 9 ? cd.hours + ':' : '0' + cd.hours + ':';
        document.getElementById('minutes').innerHTML = cd.minutes > 9 ? cd.minutes + ':' : '0' + cd.minutes + ':';
        document.getElementById('seconds').innerHTML = cd.seconds > 9 ? cd.seconds : '0' + cd.seconds;
      }

      erase() {
        document.getElementById('days').innerHTML = '';
        document.getElementById('hours').innerHTML = '';
        document.getElementById('minutes').innerHTML = '';
        document.getElementById('seconds').innerHTML = '';
      }

      timer() {
        return setTimeout(() => {
          if (this.isComplete()) {
            if (this.hideOnComplete == 'true') {
              this.style.display = 'none';
              document.getElementById('content').innerHTML = '';
            } else {
              if (this.contentComplete != '') {
                document.getElementById('content').innerHTML = this.contentComplete;
              }
              if (this.linkComplete != '') {
                document.getElementById('linkAnnouncement').setAttribute('href', this.linkComplete);
              }
            }
            clearTimeout(this.ticker);
            this.erase();
          } else if (this.countdownDate instanceof Date && isNaN(this.countdownDate)) {
            document.getElementById('content').innerHTML = this.content;
            this.erase();
          } else {
            this.tick();
            this.ticker = this.timer();
          }
        }, 1000);
      }
    },
  );
}
